// extracted by mini-css-extract-plugin
module.exports = {"enter":"animationPrev_enter__2EHaf","enterActive":"animationPrev_enterActive__2OVnN","exit":"animationPrev_exit__2VMvq","exitActive":"animationPrev_exitActive__1E8bg"};